import { APIClient } from '@frontend/api-utils';
import { AttributeExtended, AttributeExtendedLinkedProductListResponse } from '@frontend/attribute/types';

export class AttributeExtendedClient extends APIClient {
    public static readonly endpoint = '/product-api/ext/v1';

    public static async fetchExtendedAttribute(accountId: string, attributeId: string): Promise<AttributeExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}`);
        return await this.handleResponse<AttributeExtended>(response);
    }

    public static async fetchAttributeLinkedProducts(accountId: string, attributeId: string): Promise<AttributeExtendedLinkedProductListResponse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/attributes/${attributeId}/linked-products`);
        return await this.handleResponse<AttributeExtendedLinkedProductListResponse>(response);
    }
}
